import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Investments } from 'src/app/Models/investments';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-investment',
  templateUrl: './investment.component.html',
  styleUrls: ['./investment.component.css']
})
export class InvestmentComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Investments;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Investments form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.YEAR_NAME == undefined || this.data.YEAR_NAME=="") {
      this.message.error("Please Enter Year Name" , "");
      isOk = false
    }
    if (this.data.AMOUNT == undefined || this.data.AMOUNT==0) {
      this.message.error("Please Enter Amount" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE == undefined || this.data.PERCENTAGE==0) {
      this.message.error("Please Enter Percentage" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE_TOTAL == undefined || this.data.PERCENTAGE_TOTAL==0) {
      this.message.error("Please Enter Total Percentage" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No" , "");
      isOk = false
    }

    if(isOk){

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateInvestments(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Investments information updated Successfully...", "");

	this.logtext = 'Update & Close - Investments form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Investments ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Investments form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Investments ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update investments information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createInvestments(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Investments information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Investments form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Investments ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Investments();
	this.logtext = 'Save & New - Investments form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Investments ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add investments information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Investments form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Investments ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}